var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('v-app-bar',{attrs:{"app":"","color":"colorPtBlue","dark":""}},[_c('v-spacer'),_c('v-btn',{attrs:{"href":"https://www.providertrust.com/","target":"_blank","text":""}},[_c('span',{staticClass:"mr-2"},[_vm._v("Website")]),_c('v-icon',[_vm._v("fas fa-external-link-alt")])],1)],1),_c('v-main',[_c('HelloWorld')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }